import HttpRequest from './HttpRequest'
import HttpResponse from './HttpResponse'
import {httpClient} from "../HttpClient";
import {chunk} from "../../utils";

export default class HttpSender {
    private history: { request: HttpRequest, response: HttpResponse }[] = []

    async sendRequestsInBatches(
        requests: HttpRequest[],
        onResponse: (request: HttpRequest, response: HttpResponse, index: number) => void
    ) {
        const indexedRequests = requests.map((request, index) => ({ request, index }))

        const batchPromises = chunk(indexedRequests, 10).map(async (requestsChunk) => {
            const payload = requestsChunk.map(({ request }) => ({
                method: request.method,
                path: request.path,
                body: request.body
            }))

            const batchResponseData = await httpClient.post('/batch', {
                data: payload
            })

            if (batchResponseData.status === 200 && Array.isArray(batchResponseData.data.data)) {
                batchResponseData.data.data.forEach((responseData: any, batchIndex: number) => {
                    const originalIndex = requestsChunk[batchIndex].index;
                    const request = requestsChunk[batchIndex].request
                    const response = new HttpResponse(responseData.status, responseData.body)

                    this.history.push({ request, response })

                    onResponse(request, response, originalIndex)
                })
            }
        })

        await Promise.all(batchPromises)
    }

    async sendRequestsInBatchesSuccessively(
        requests: HttpRequest[],
        onResponse: (request: HttpRequest, response: HttpResponse, index: number) => void
    ) {
        const indexedRequests = requests.map((request, index) => ({ request, index }))

        const chunks = chunk(indexedRequests, 10)

        for (const requestsChunk of chunks) {
            const payload = requestsChunk.map(({ request }) => ({
                method: request.method,
                path: request.path,
                body: request.body
            }))

            const batchResponseData = await httpClient.post('/batch', {
                data: payload
            })

            if (batchResponseData.status === 200 && Array.isArray(batchResponseData.data.data)) {
                batchResponseData.data.data.forEach((responseData: any, batchIndex: number) => {
                    const originalIndex = requestsChunk[batchIndex].index;
                    const request = requestsChunk[batchIndex].request
                    const response = new HttpResponse(responseData.status, responseData.body)

                    this.history.push({ request, response })

                    onResponse(request, response, originalIndex)
                })
            }
        }
    }    

    async sendRequests(
        requests: HttpRequest[],
        onResponse: (request: HttpRequest, response: HttpResponse, index: number) => void
    ) {
        const requestPromises = requests.map(async (request, index) => {
            let responseData = await httpClient.get(request.path, request.body);

            const response = new HttpResponse(responseData.status, responseData.data)

            this.history.push({ request, response })

            onResponse(request, response, index)
        });

        await Promise.all(requestPromises);
    }

    getHistory(): { request: HttpRequest, response: HttpResponse }[] {
        return this.history
    }
}
